import { BasicPartnerApi } from "../../../../../services/Api/Partner/partnerTypes";

export const isPosnetPartner = (partner: BasicPartnerApi | undefined) => {
	if (partner) {
		return partner.slug === "posnet";
	}
	return false;
};
